import React from "react";
import image13 from "../Assets/sumit.jpg";
import image2 from "../Assets/mehendigif.gif";
import { Link } from "react-router-dom";
import { FaInstagram } from "react-icons/fa";
import ReviewSlider from "../components/core/home/newhomepage/ReviewSlider";
import Formabout from "./Formabout";

export default function AboutUs() {
  return (
    <div className="container mx-auto p-6">
      {/* Section 1: Personal Info */}
      <div className="flex flex-col lg:flex-row items-center justify-center bg-white rounded-lg shadow-lg overflow-hidden mb-12">
        <div className="w-full lg:w-1/3 flex items-center justify-center">
          <img
            src={image13}
            alt="Your Name"
            className="lg:w-[15rem] lg:h-[24rem] lg:ml-16 md:w-[15rem]  rounded-t-xl object-cover"
          />
        </div>
        <div className="w-full lg:w-2/3 p-8">
          <h3 className="text-3xl font-bold text-richblack-600 mb-4 font-roboto">Mr Sumit Kumar</h3>
          <p className="text-richblack-500 mb-6 font-mono ">
          I'm Sumit Kumar, a passionate Mehendi artist based in Delhi with over 10 years of experience 
          in the art of Mehendi design. My journey in this craft has been fueled by a deep love for 
          creating intricate and meaningful patterns that celebrate tradition and beauty. I specialize
           in both traditional and contemporary Mehendi styles, ensuring each design is a unique reflection
            of your special occasion. My commitment to quality, attention to detail, and dedication to 
            client satisfaction have earned the trust of countless clients. Let me bring your vision to 
            life with my artistic expertise.
          </p>
          <Link
            to="https://www.instagram.com/mehendidreams_1?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-[#CFAB08] hover:text-[#ac942b] text-lg font-semibold"
          >
            <FaInstagram/> Follow me on Instagram
          </Link>
        </div>
      </div>

      {/* Section 2: GIF Image & Contact Form */}
      <div className="flex flex-col lg:flex-row items-center justify-between bg-richblack-600 shadow-xl p-8 rounded-lg ">
        <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
          <img
            src={image2}
            alt="Mehendi Design"
            className="w-full h-full object-cover rounded-lg"
          />
        </div>

        <div className="w-full lg:w-1/2 lg:ml-8 border-l-2 pl-3 border-[#C4A135]">
          <h2 className="text-4xl font-bold text-center lg:text-left font-roboto text-[#c9ac2d]">
            Contact Us for Mehendi Design
          </h2>
          <Formabout/>
          
        </div>
      </div>
      <div className="mt-10">
      <ReviewSlider/>
      </div>
      
    </div>
  );
}
